import { _ } from "../../core/polyglot/polyglot.js";
import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import LedgerEntryTableWidget from "../ledgerEntry/LedgerEntryTableWidget/LedgerEntryTableWidget.js";
import linkedDocumentService from "./linkedDocumentService.js";
import notifier from "../../core/widgets/notifier/notifier.js";
import session from "../../core/session.js";
import state from "../../core/state.js";
import Transaction from "../../models/Transaction.js";
import TransactionList from "../../models/TransactionList.js";
import windowedDocument from "./windowedDocument.js";

/**
 * A document that displays a ledger entry for a fiscal year.
 *
 * @param {object} spec - Object configuration
 * @param {object} my - Protected properties
 */
function ledgerEntryDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = windowedDocument(spec, my);

	my.state = state.empty;

	// Ledger and it's transactions
	let ledgerEntry;
	let transactionList;
	let dimensionIdentifier;

	that.headerTitle = _("Transaction");
	that.title = _("Transaction");

	my.transactionRepository = makeMonitorRepository({
		route: "/Accounting2/Company/#companyId/Transaction/",
		model: Transaction,
		defaultFilters: {
			companyId: session.getCompany().getLegacyId(),
		},
		antiForgeryToken: session.getAntiForgeryToken(),
	});

	that.hasPeriodPicker = function () {
		return false;
	};

	/**
	 * @param {string} options.ledgerId - Id of the ledger
	 * @param {string} options.fiscalYearId - Id of the fiscal year
	 * @param {string} options.dimensionIdentifier - Id of the dimension
	 */
	that.showLedgerEntry = async function (options) {
		const ledgerId = options.ledgerId;
		const fiscalYearId = options.fiscalYearId;
		dimensionIdentifier = options.dimensionIdentifier;

		that.showUpdating();

		ledgerEntry = null;
		transactionList = [];

		const data = await my.transactionRepository.get({
			filter: {
				fiscalYearId,
				ledgerId,
			},
		});

		// TODO: this should be a ledger entry with it's transactions the model is not correct
		transactionList = new TransactionList({ transactions: data });
		if (transactionList.hasTransaction()) {
			ledgerEntry = transactionList.getLedgerEntry();
		}

		that.showContent();
	};

	my.renderContentOn = function (html) {
		html.div(
			{ class: "panel-body panel-body-white" },
			html.div(
				{ class: "panel-title" },
				html.p(
					{ class: "subtitle" },
					ledgerEntry.getSeries(),
					" ",
					ledgerEntry.getNumber(),
					(html) => {
						if (!ledgerEntry.getText()) {
							return;
						}
						html.span(" - ", ledgerEntry.getText());
					},
					renderIconOn,
				),
			),
		);

		html.render(
			new LedgerEntryTableWidget({
				transactionList,
				dimensionIdentifier,
			}),
		);
	};

	function renderIconOn(html) {
		if (!ledgerEntry.hasLinkedDocument()) {
			return;
		}
		if (linkedDocumentService.haveLinkedDocumentIntegration()) {
			html.a(
				{
					style: "display: inline-block",
					href: linkedDocumentService.getByLedgerEntry(ledgerEntry),
					target: "_blank",
				},
				html.div({
					class: "ledger-icon fp-icon advisory-report-icon",
				}),
			);
		} else {
			html.a(
				{ style: "display: inline-block" },
				html.div({
					class: "ledger-icon fp-icon advisory-report-icon",
				}),
			).click(() => {
				notifier.error(
					_(
						"Please re-authenticate by using the import wizard or contact your local support.",
					),
				);
			});
		}
	}

	return that;
}

export default ledgerEntryDocument;
